import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from './ui/dialog';
import { Button } from './ui/button';
import { Crown, ShoppingCart, CheckSquare, Users, Package, Receipt } from 'lucide-react';

const RESOURCE_CONFIG = {
  orders: { icon: ShoppingCart, label: 'заказов', color: 'text-blue-500', bg: 'bg-blue-500/10' },
  tasks: { icon: CheckSquare, label: 'задач', color: 'text-purple-500', bg: 'bg-purple-500/10' },
  customers: { icon: Users, label: 'клиентов', color: 'text-orange-500', bg: 'bg-orange-500/10' },
  materials: { icon: Package, label: 'материалов', color: 'text-teal-500', bg: 'bg-teal-500/10' },
  invoices: { icon: Receipt, label: 'счетов', color: 'text-amber-500', bg: 'bg-amber-500/10' },
};

export default function PaywallDialog({ open, onClose, resourceType, limit }) {
  const navigate = useNavigate();
  const config = RESOURCE_CONFIG[resourceType] || RESOURCE_CONFIG.orders;
  const Icon = config.icon;

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <div className="flex justify-center mb-3">
            <div className={`h-14 w-14 rounded-2xl ${config.bg} flex items-center justify-center`}>
              <Icon className={`h-7 w-7 ${config.color}`} />
            </div>
          </div>
          <DialogTitle className="text-center text-lg">
            Лимит демо-версии достигнут
          </DialogTitle>
          <DialogDescription className="text-center">
            В демо-версии доступно до <strong>{limit} {config.label}</strong>.
            Перейдите на тариф <span className="text-emerald-500 font-semibold">Про</span> для безлимитного использования.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex-col gap-2 sm:flex-col">
          <Button
            className="w-full bg-emerald-500 hover:bg-emerald-600 text-white h-11 gap-2"
            onClick={() => {
              onClose(false);
              navigate('/pricing');
            }}
          >
            <Crown className="h-4 w-4" />
            Посмотреть тарифы
          </Button>
          <Button variant="outline" className="w-full" onClick={() => onClose(false)}>
            Закрыть
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
